<template>
  <v-container
    fluid
    class="pa-12 pb-2"
  >
    <v-row>
      <v-col>
        <CharityFAQForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import CharityFAQForm from '@/components/infoForms/CharityFAQForm';

export default {
  components: {
    CharityFAQForm,
  },

  data: () => ({
    courseEnrollments: [],
  }),

  computed: {
    ...mapState({
      userId: (state) => state.user.nameId,
    }),
  },

  created() {
    this.init();
  },

  methods: {
    init() {
    },
  },
};
</script>
